import { useState } from "react";
import { Box, IconButton, Stack } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";
import { theme } from "src/assets/theme";

interface Props {
  onFocus?: () => void;
  children: React.ReactNode;
  length: number;
  gap?: number;
}

const Carousel = ({ onFocus, children, length, gap }: Props) => {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((i) => (i + 1) % length);

  return (
    <Stack
      direction="row"
      gap={gap}
      sx={{
        position: "relative",
        width: "95%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        sx={{
          borderRadius: "10px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: `${length * 100}%`,
            transform: `translateX(-${index * (100 / length)}%)`,
            transition: "transform 0.4s ease",
            zIndex: 0,
          }}
          onClick={onFocus}
        >
          {children}
        </Box>
      </Stack>
      <IconButton
        size="small"
        sx={{
          position: "absolute",
          top: "50%",
          right: -40,
          transform: "translateY(-50%)",
          color: theme.palette.primary.main,
          zIndex: 1000,
        }}
        aria-label="Next review"
        onClick={next}
      >
        <ArrowForwardIos fontSize="large" />
      </IconButton>
    </Stack>
  );
};

export default Carousel;
